module.exports = __webpack_public_path__ + "img/21_newModelWorker_zmh.4fa80c49.png";